export const useContactStore = defineStore('StoreContact', {
    state: () => ({
        contact: null as ContactInfo | null,
        disabled: false as boolean,
        success: null as string | null,
        error: null as string | null,
    }),
    actions: {
        initContact() {
            this.contact = {
                first_name: '',
                last_name: '',
                email: '',
                telephone: '',
                message: '',
                recaptcha: '',
            };
        },
        updateContactField({field, value}: FieldValue) {
            if (!this.contact) throw Error('Cannot update contact field because the object has not been initialised.');
            if (this.contact[field] === undefined)
                throw new Error('Attempted to update a contact field which does not exist (' + field + ').');
            this.contact[field] = value;
        },
        async postContact() {
            this.success = null;
            this.error = null;
            this.disabled = true;
            ({error: this.error} = await useEntityContact().post(this.contact));
            if (!this.error) {
                this.success = 'Thanks, we have received your message and will be in touch soon.';
                this.initContact();
            }
            this.disabled = false;
        },
        clearError() {
            this.error = null;
        },
        clearSuccess() {
            this.success = null;
        },
    },
});

interface ContactInfo {
    first_name: string;
    last_name: string;
    email: string;
    telephone: string;
    message: string;
    recaptcha: string;
}

interface FieldValue {
    field: keyof ContactInfo;
    value: string;
}

interface ApiError {
    alert: string;
}
